export default __webpack_public_path__ + "static/b-user-testing-screen-1-f108288f63bdbd0ee2fd0f1c01806dca.jpg";